import * as React from 'react';
import apiString from '../services/apiString.js';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Person from '@mui/icons-material/Person';
import Home from '@mui/icons-material/Home';
import Info from '@mui/icons-material/Info';
import Email from '@mui/icons-material/Email';
import Settings from '@mui/icons-material/Settings';
import PowerSettings from '@mui/icons-material/PowerSettingsNew';

function handleMobile() {

  if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }

}

let styles = {
  pages: { 
    display: 'flex', 
    flexDirection: 'row' 
  },
  text: {
    textTransform: 'none',
    marginTop: 2,
    color: handleMobile() === true ? '#343434' : '#fff'
  },
  text2: {
    textTransform: 'none',
    marginTop: 2,
    color: '#323232'
  }
}

const pages = [
  <div style={styles.pages} onClick={handleHome}>
    <Home style={{ color: handleMobile() === true ? '#343434' : '#fff' }} />
    <Typography style={styles.text}>Início</Typography>
  </div>,
  <div style={styles.pages}>
    <Info style={{ color: handleMobile() === true ? '#343434' : '#fff' }} />
    <Typography style={styles.text}>Sobre</Typography>
  </div>,
  <div style={styles.pages}>
    <Email style={{ color: handleMobile() === true ? '#343434' : '#fff' }} />
    <Typography style={styles.text}>Contato</Typography>
  </div>
];
const settings = [
  <div style={styles.pages}>
    <Person />
    <Typography style={styles.text2}>Perfil</Typography>
  </div>,
  <div style={styles.pages}>
    <Settings />
    <Typography style={styles.text2}>Configurações</Typography>
  </div>,
  <div style={styles.pages} onClick={handleExit}>
    <PowerSettings />
    <Typography style={styles.text2}>Sair</Typography>
  </div>
];

function handleHome() {

  let urlString = window.location.href;

  if (!urlString.includes('home')) {
    window.location.href = `${apiString}/citzenhome`;
  }

}

function handleExit() {
  window.location.href = `${apiString}`;
}

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" style={{ backgroundColor: '#048138' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Abrir Opções">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar style={{ backgroundColor: '#FFF', color: '#323232' }} >
                  <Person />
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;